<template>
    <div class="portfolio-header">
        <section style="overflow-x: hidden!important" class="stipple-bg">
            <b-container class="header d-md-flex flex-column justify-content-center">
                <b-row>
                    <b-col md="7" class="pr-md-0">
                        <img src="/img/pride-and-joy.svg" alt="Pride and Joy" class="w-100 d-block max-w-500 h-auto fade-in-up-element" width="500" height="375">
                    </b-col>
                    <b-col md="5" class="d-flex flex-column justify-content-end ">
                        <div class="gotham-book mb-0 bodycopy-text mt-md-0 mt-5">
                            <p class="h3 gotham-bold">
                                {{ pageName }} <span class="gotham-book mb-0 bodycopy-text mt-3">
                                {{ pageSubName }}
                                </span>
                            </p>
                        </div>
                        <div class="gotham-book mb-0 bodycopy-text mt-3">
                            <span class="gotham-bold mb-2 d-block">
                                DISCIPLINE
                            </span>
                            <p v-for="(discipline, i) in disciplines" :key="i" class="gotham-book text-uppercase mb-1 bodycopy-text">
                                {{discipline.name}}
                            </p>
                        </div>
                        <div class="gotham-book rbodycopy-text mt-4">
                            <span class="gotham-bold mb-2 d-block">
                                SERVICES
                            </span>
                            <p v-for="(service, i) in services" :key="i" class="gotham-book text-uppercase mb-1 bodycopy-text">
                                {{service.name}}
                            </p>
                        </div>
                        <br>
                        <div class="icon-page-link">
                            <img v-if="iconLink" :src="iconLink" alt="icon-link" class="icon-link"/>
                            <a :href="pageLink" target="_blank" class="gotham-bold text-black text-uppercase d-inline-block">{{linkName}}</a>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>
    </div>
</template>

<script>
export default {
    props: ['pageName', 'pageSubName', 'disciplines', 'services', 'iconLink', 'pageLink', 'linkName']
}
</script>

<style scoped lang="scss">
.portfolio-header {
    .header {
        min-height: 800px;

        @media screen and (max-width: 767px) {
            padding: 140px 15px;
            min-height: unset;
            height: auto;
        }
    }

    .icon-page-link {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .icon-link {
        width: 10px;
        height: 10px;
    }

}
</style>